<template>
  <div
    ref='modal'
    class='modal'
    :style="{
      justifyContent: modalForMobile ? 'flex-end' : null,
      background: 'none'
    }"
    @click.stop
  >
    <div class='field' @click.stop="$emit('close')" :style="onlyModal ? 'background: none' : null"></div>
    <div class='window' :style='windowStyle'>

      <div class="modal__head" style="margin-bottom: 32px">
        <slot name="header">
          <h3 class="modal__title">{{ title }}</h3>
        </slot>
        <button v-if='hasCloseButton' class="close" @click.stop="$emit('close')">
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2" />
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2" />
          </svg>
        </button>
      </div>

      <div class="modal__body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BaseModal',
  emits: ['close'],
  props: {
    onlyModal: {
      type: Boolean,
      default: false
    },
    title: String,
    height: {
      type: String,
      default: 'fit-content'
    },
    width: {
      type: String,
      default: 'fit-content'
    },
    padding: {
      type: String,
      default: ''
    },
    hasCloseButton: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: String,
      default: '100%'
    },
    mobileStyle: {
      type: Object,
      default: () => ({})
    },
    desktopStyle: {
      type: Object,
      default: () => ({})
    },
    background: {
      type: String,
      default: ''
    }
  },
  mounted () {
    if (this.$refs.modal.style.display !== 'none') document.querySelector('body').style.overflow = 'hidden'
  },
  beforeDestroy () {
    document.querySelector('body').style.overflow = 'auto'
  },
  computed: {
    ...mapState(['isMobile', 'windowHeight', 'windowWidth']),
    modalForMobile () {
      return this.isMobile || this.windowHeight < 415
    },
    baseDesktopStyle () {
      return {
        width: this.width,
        height: this.height,
        padding: this.padding,
        borderRadius: this.borderRadius,
        margin: 'auto',
        background: this.background,
        overflow: null
      }
    },
    baseMobileStyle () {
      return {
        width: '100%',
        height: null,
        padding: this.padding,
        borderRadius: '12px 12px 0 0',
        maxHeight: this.maxHeight,
        background: this.background,
        overflow: 'auto'
      }
    },
    windowStyle () {
      const mobileStyle = {
        ...this.baseMobileStyle,
        ...this.mobileStyle
      }
      const desktopStyle = {
        ...this.baseDesktopStyle,
        ...this.desktopStyle
      }
      return this.modalForMobile ? mobileStyle : desktopStyle
    }
  }
}
</script>

<style scoped lang="scss">
.modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: var(--z-index__modal);
  overflow-y: auto;
  .field {
    position: fixed;
    left: -50%;
    top: -50%;
    display: block;
    width: 1000%;
    height: 1000%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1000;
    animation: backOpacity 0.2s linear;
  }
  @keyframes backOpacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .window {
    display: flex;
    flex-direction: column;
    min-width: 280px;
    height: auto;
    background: #ffffff;
    box-shadow: 0 28px 30px -20px rgba(0, 0, 0, 0.25);
    z-index: 1001;
    position: relative;
    animation: windowAnime 0.2s ease-in-out;
    color: black;
    box-sizing: border-box;
  }
  @keyframes windowAnime {
    0% {
      opacity: 0;
      transform: translate3d(0px, 100%, 0px);
    }
    100% {
      opacity: 1;
      transform: translate3d(0px, 0px, 0px);
    }
  }

  // temp, можно использовать вместо svg
  .close-modal {
    background: none;
    position: absolute;
    top: 10px;
    right: 10px;
    border: none;
    width: 20px;
    height: 20px;
    line-height: 15px;
    font-size: 22px;
    font-weight: bold;
    cursor: pointer;
    outline: none;
    &:hover:before,
    &:hover:after {
      background: #666871;
    }
    &:before,
    &:after {
      content: "";
      position: absolute;
      top: 8px;
      right: 0;
      width: 18px;
      height: 4px;
      // background: #aaa;
    }
    &:before {
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
    &:after {
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
    }
  }
}
</style>
